import { compose } from 'recompose';
import { connect } from 'react-redux';
import { canActiveShopUseMemberships, canActiveBrandUseMemberships } from '../../../auth/selectors';
import withActiveUserIdAndType from '../../../common/hoc/withActiveUserIdAndType';

export default compose(
    withActiveUserIdAndType(),
    connect((state, props) => {
      let canSeeMembershipsData = false;

      if (props.activeType === 'shop') {
        canSeeMembershipsData = canActiveShopUseMemberships(state);
      }

      if (props.activeType === 'brand') {
        canSeeMembershipsData = canActiveBrandUseMemberships(state);
      }

      return { canSeeMembershipsData };
    }),
);
